/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_No_Events_To_ExportInputs */



/**
* | output |
* | --- |
* | "No events found to export" |
*
* @param {Image_Export_No_Events_To_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_no_events_to_export = /** @type {((inputs?: Image_Export_No_Events_To_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_No_Events_To_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement a exporter")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine zu exportierenden Ereignisse gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento trovato da esportare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События для экспорта не найдены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron eventos para exportar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到要导出的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートするイベントが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात करने के लिए कोई इवेंट नहीं मिले")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento encontrado para exportar.")
	return /** @type {LocalizedString} */ ("No events found to export")
});